import React, { FunctionComponent, useState } from 'react';
import { Link } from 'react-router-dom';
import { useGetBackofficePostulationsQuery } from 'services/exploreApi';
import { CommonHash } from 'app/types';
import styles from './Postulations.module.scss';
import Text from 'common/components/Text/Text';
import Table from 'common/components/NewTable/NewTable';
import Loader from 'common/components/Loader/Loader';
import { logoutUser } from 'features/session/sessionSlice';
import { useAppDispatch } from 'app/hooks';
import { setProfileCompleted, setProfileProgress } from 'features/user/userSlice';

const columns = [
  { name: 'id', header: 'ID', type: 'number', defaultWidth: 60 },
  {
    name: 'email',
    defaultFlex: 1,
    header: 'EMAIL',
  },
  {
    name: 'school_name',
    defaultFlex: 1,
    header: 'SCHOOL NAME',
  },
  {
    name: 'program_name',
    defaultFlex: 1,
    header: 'PROGRAM NAME',
  },
  {
    name: 'study_option',
    defaultFlex: 1,
    header: 'STUDY OPTION',
  },
  {
    name: 'intake_date',
    defaultFlex: 1,
    header: 'INTAKE DATE',
  },
  {
    name: 'deadline_date',
    defaultFlex: 1,
    header: 'DEADLINE DATE',
  },
  {
    name: 'created_at',
    defaultFlex: 1,
    header: 'CREATED AT',
  },
  {
    name: 'action',
    defaultFlex: 1,
    header: 'ACTIONS',
    render: ({ data }: { data: CommonHash }) => {
      return (
        <div>
          <Link to={`/backoffice/applications/${data.id}`}>
            <i className="bi bi-eye" />
          </Link>
        </div>
      );
    },
  },
];

const defaultFilterValue = [
  { name: 'email', operator: 'contains', type: 'string', value: '' },
  { name: 'school_name', operator: 'contains', type: 'string', value: '' },
  { name: 'program_name', operator: 'contains', type: 'string', value: '' },
];

const defaultSort = { name: 'created_at', dir: -1 };
const Postulations: FunctionComponent = () => {
  const [limit, setLimit] = useState(25);
  const [page, setPage] = useState(1);
  const [filterValue, setFilterValue] = useState(defaultFilterValue);
  const { data: applications, isLoading } = useGetBackofficePostulationsQuery({
    page_size: limit,
    page: page,
    query: JSON.stringify(filterValue),
  });
  const dispatch = useAppDispatch();
  dispatch(logoutUser());
  dispatch(setProfileCompleted(false));
  dispatch(setProfileProgress({}));

  if (isLoading) return <Loader />;
  return (
    <div className="w-100 pt-3">
      <Text size={30} weight={800} inlineStyle={{ marginBottom: '30px', marginLeft: '20px' }}>
        Applications
      </Text>
      <Table
        columns={columns}
        data={applications ? applications.data : []}
        filters={filterValue}
        defaultSort={defaultSort}
        total={applications?.meta.total || 0}
        limit={limit}
        setLimit={setLimit}
        page={page}
        setPage={setPage}
        setFilterValue={setFilterValue}
      />
    </div>
  );
};

export default Postulations;
